import Vue from 'vue'

import JImagePreviewComponent from "./JImagePreview.vue";

let JImagePreviewConstructor = Vue.extend(JImagePreviewComponent)
let instance


const JImagePreview = function (option = {}) {
    instance = new JImagePreviewConstructor({
        propsData: option
    })
    instance.$mount()
    document.body.appendChild(instance.$el)
    instance.remove = function () {
        document.body.removeChild(instance.$el)
        instance.$destroy()
    }
}

Vue.prototype.$JImagePreview = JImagePreview

export default JImagePreview
